(function () {
  'use strict';

  function slugify(text) {
    return String(text)
      .toLowerCase()
      .trim()
      .replace(/[‘’“”]/g, '')
      .replace(/&[a-z]+;/g, ' ')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80) || 'section';
  }

  function ensureUniqueId(id, used) {
    let candidate = id;
    let n = 2;
    while (used.has(candidate) || document.getElementById(candidate)) {
      candidate = id + '-' + n++;
    }
    used.add(candidate);
    return candidate;
  }

  function buildToc(root) {
    const body = root.querySelector('[data-article-body]');
    const toc = root.querySelector('[data-article-toc]');
    const list = root.querySelector('[data-article-toc-list]');
    const faqsLink = root.querySelector('[data-article-toc-faqs]');
    if (!body || !toc || !list) return;

    const headings = body.querySelectorAll('h2');
    if (!headings.length) {
      toc.remove();
      return;
    }

    const used = new Set();
    const frag = document.createDocumentFragment();

    headings.forEach((h) => {
      const text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) h.id = ensureUniqueId(slugify(text), used);
      else used.add(h.id);

      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      frag.appendChild(li);
    });

    if (!frag.childNodes.length) {
      toc.remove();
      return;
    }

    list.appendChild(frag);
    toc.hidden = false;

    if (faqsLink && document.getElementById('faqs')) {
      faqsLink.hidden = false;
    }

    // Active-link highlighting via IntersectionObserver
    if ('IntersectionObserver' in window) {
      const links = new Map();
      list.querySelectorAll('a[href^="#"]').forEach((link) => {
        links.set(link.getAttribute('href').slice(1), link);
      });

      let active = null;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const link = links.get(entry.target.id);
            if (!link) return;
            if (entry.isIntersecting) {
              if (active) active.classList.remove('is-active');
              link.classList.add('is-active');
              active = link;
            }
          });
        },
        { rootMargin: '-20% 0px -70% 0px', threshold: 0 }
      );

      headings.forEach((h) => observer.observe(h));
    }
  }

  function init() {
    document.querySelectorAll('.dynamic-main-article').forEach(buildToc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
